<template>
  <v-app style="background: #eee" class="pa-3">
    <div>
      <span class="display-1 font-weight-light">Currently Open Posts</span>
      <v-divider />
      <br />
      <v-layout row wrap>
        <span v-if="openPosts.length==0" class="subheading">You have no currently open posts.</span>
        <v-flex xs12 sm6 md4  v-for="doc in openPosts">
          <div class="mr-4 ml-4 mb-4">
            <PostCard
              :source=doc.data().source
              :destination=doc.data().destination
              :cab_booked=doc.data().cab_booked
              :date=doc.data().date_time.toDate().toLocaleDateString()
              :time=doc.data().date_time.toDate().toLocaleTimeString().substr(0,5)
              :accept_limit=doc.data().accept_limit
              :accepted_count=doc.data().accepted.length
              :posted_by=doc.data().posted_by
              :postId=doc.id
              :accepted=doc.data().accepted
              :requests=doc.data().requests
            />
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div class="pt-4">
      <span class="display-1 font-weight-light">Closed Posts</span>
      <v-divider />
      <br />
      <v-layout row wrap>
        <span v-if="closedPosts.length==0" class="subheading">You have no closed posts.</span>
        <v-flex xs12 sm6 md4  v-for="doc in closedPosts">
          <div class="mr-4 ml-4 mt-4">
            <ClosedPostCard
              :source=doc.data().source
              :destination=doc.data().destination
              :cab_booked=doc.data().cab_booked
              :date=doc.data().date_time.toDate().toLocaleDateString()
              :time=doc.data().date_time.toDate().toLocaleTimeString().substr(0,5)
              :accept_limit=doc.data().accept_limit
              :accepted_count=doc.data().accepted.length
              :posted_by=doc.data().posted_by
              :postId=doc.id
              :accepted=doc.data().accepted
              :requests=doc.data().requests
            />
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div v-if="dialog">
      <Popup2 :dialog="dialog" @hide="back" @updatePosts="updatePostsArray"></Popup2>
    </div>
    <v-fab-transition>
      <v-btn color="amber" dark fab fixed bottom right large class="mb-4 mr-4" @click="create">
        <v-icon color="#35455c">add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >{{ text }}</v-snackbar>
  </v-app>
</template>

<script>
import Popup2 from "@/components/Popup2.vue";
import PostCard from "@/components/PostCard.vue";
import ClosedPostCard from "@/components/ClosedPostCard.vue";
import firebase, { functions } from 'firebase';
export default {
  name: "Post",
  components: {
    Popup2,
    PostCard,
    ClosedPostCard
  },
  data() {
    return {
      listener:null,
      myPosts: [],
      dialog: false,

      //Snackbar data
      snackbar: false,
      color: '',
      mode: '',
      timeout: 4000,
      text: '',
    };
  },
  methods: {
    back() {
      this.dialog = false;
    },
    create() {
      this.dialog = true;
    },
    updatePostsArray(){
      var vm = this;
      vm.color="success";
      vm.text="Post added successfully.";
      vm.snackbar=true;       
    }
  },

  mounted(){
    const db = firebase.firestore();
    var vm = this;
    vm.listener=db.collection('posts')
    .where('posted_by.uid', '==', firebase.auth().currentUser.uid)
    .orderBy('time_posted', 'desc')
    .onSnapshot(function(snap){
      vm.myPosts = snap.docs;
    })
  },

  computed: {
    openPosts: function(){
      let open = [];
      for (var post of this.myPosts){
        if(post.data().post_closed==false){
          open.push(post);
        }
      }
      return open;
    },

    closedPosts(){
      let closed = [];
      for (var post of this.myPosts){
        if(post.data().post_closed==true){
          closed.push(post);
        }
      }
      return closed;
    }
  },
  
  beforeDestroy(){
    this.listener();
  }
};
</script>
